var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCnChina(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_9276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V45H60V0Z",
    fill: "#EE1C25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8 16.65L48.7501 4.5L44.7001 16.65L55.5 9.225H42.0002L52.8 16.65Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2337 4.73287L39.4016 5.65651L36.6214 2.41682L36.8941 6.77701L39.207 2.91693L35.2337 4.73287Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0277 10.0638L35.2276 9.29869L31.4086 7.39084L33.3509 11.304L33.9858 6.849L31.0277 10.0638Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6409 17.5429L35.1636 15.1313L30.8985 14.947L34.268 17.7277L33.0306 13.4011L31.6409 17.5429Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.939 22.4288L39.2569 18.8438L35.2516 20.3211L39.4336 21.5846L36.6212 18.0717L36.939 22.4288Z",
    fill: "#FFFF00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_9276"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCnChina);
export default __webpack_public_path__ + "static/media/cn China.aea14c55b4056acbe1b0801467fae779.svg";
export { ForwardRef as ReactComponent };